export function mapPropsVariants<T extends object, K extends keyof T>(
  props: T,
  variantKeys: K[],
): readonly [Omit<T, K>, Pick<T, K>] {
  const picked = variantKeys.reduce<Pick<T, K>>(
    (acc, key) => {
      // Only include the key in `picked` if it exists in `props`
      if (key in props) {
        acc[key] = props[key]
      }
      return acc
    },
    // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- empty typed Pick seed
    {} as Pick<T, K>,
  )

  const variantKeysSet = new Set<PropertyKey>(variantKeys)
  const omitted = Object.fromEntries(Object.entries(props).filter(([key]) => !variantKeysSet.has(key)))

  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- omitted holds non-variant keys
  return [omitted as Omit<T, K>, picked]
}
